import React, { SVGProps } from 'react';

function DeletedUserIndicator(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="7" height="7" rx="3.5" fill="#AE0C0C" />
    </svg>
  );
}

export default DeletedUserIndicator;
